import { TableModel } from "@/components/table-v2/models";
import { literal } from "superstruct";
import { RENDER_TYPE } from "./consts";
export const RenderTypeModel = literal(RENDER_TYPE);
const TableContentModel = TableModel;
export default TableContentModel;
